import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Debug RPC calls
const originalRpc = supabase.rpc.bind(supabase);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(supabase as any).rpc = function(fn: string, args?: Record<string, unknown>, options?: Record<string, unknown>) {
  console.log(`[RPC] Calling ${fn} with args:`, args);
  const promise = originalRpc(fn, args, options);
  
  // Create a new promise that logs the response
  return Promise.resolve(promise).then((res: { data?: unknown; error?: unknown }) => {
    console.log(`[RPC] ${fn} response:`, res);
    console.log(`[RPC] ${fn} response data:`, res?.data);
    console.log(`[RPC] ${fn} response error:`, res?.error);
    return res;
  }).catch((err: unknown) => {
    console.error(`[RPC] ${fn} error:`, err);
    throw err;
  });
}